const sliderPDPThumbnail = new Swiper('.product-offer__nav-slider', {
  loop: true,
  slidesPerView: 5.16,
  spaceBetween: 6,
  watchSlidesProgress: true,
  breakpoints: {
    981: {
      slidesPerView: 6,
      spaceBetween: 12,
    }
  }
});

const sliderPDPMain = new Swiper('.product-offer__main-slider', {
  spaceBetween: 6,
  slidesPerView: 1.054,
  loop: true,
  thumbs: {
    swiper: sliderPDPThumbnail
  },
  pagination: {
    el: '.pdp-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-pdp',
    prevEl: '.swiper-button-prev-pdp',
  },
  breakpoints: {
    981: {
      slidesPerView: 1,
    }
  }
});

// product offer
document.addEventListener('DOMContentLoaded', () => { 
  const sections = document.querySelectorAll('.product-offer'); 
 
  sections.forEach(section => { 
    const variantItems = section.querySelectorAll('.product-offer__variant-item'); 
    const variantInput = section.querySelector('[id^="selected-variant-id"]'); 
    const buyNowBtn = section.querySelector('[id^="buy-now"]') 
    const form = buyNowBtn.closest('form'); 
    const stickyPrice = section.querySelector('.product-offer__sticky .sticky-price'); 
    const stickyCompare = section.querySelector('.product-offer__sticky .sticky-compare'); 
 
    const subscriptionCheckbox = section.querySelector('[id^="offer-subscription"]'); 
 
    const btnPrice = buyNowBtn.querySelector('.btn-price'); 
    const btnCompare = buyNowBtn.querySelector('.btn-compare'); 
 
    form.addEventListener('submit', e => e.preventDefault()); 
 
    function getSelectedVariant() { 
      return section.querySelector('.product-offer__variant-item.selected'); 
    }

    function updateDeliveryFrequency() {
      const selected = getSelectedVariant();
      const subscriptionLabel = section.querySelector('.product-offer__subscription');
      const deliveryFrequency = section.querySelector('.delivery-frequency');

      if (!selected || !deliveryFrequency || !subscriptionLabel) return;

      const delivery = selected.dataset.delivery;

      if (delivery) {
        deliveryFrequency.textContent = delivery;
        subscriptionLabel.style.display = '';
      } else {
        deliveryFrequency.textContent = '';
        subscriptionLabel.style.display = 'none';
      }
    }
 
    function updatePrices() { 
      const isSub = subscriptionCheckbox?.checked; 
 
      variantItems.forEach(item => { 
        const priceEl = item.querySelector('.el-price'); 
        const compareEl = item.querySelector('.el-compare-price'); 
 
        let price = item.dataset.price; 
 
        if (isSub && item.dataset.subscriptionPrice) { 
          price = item.dataset.subscriptionPrice; 
        } 
 
        if (priceEl) priceEl.textContent = price; 
        if (compareEl) compareEl.textContent = item.dataset.comparePrice; 
      }); 
 
      const selected = getSelectedVariant(); 
      if (!selected) return; 
 
      let activePrice = selected.dataset.price; 
 
      if (isSub && selected.dataset.subscriptionPrice) { 
        activePrice = selected.dataset.subscriptionPrice; 
      } 
 
      btnPrice.textContent = activePrice; 
 
      if (selected.dataset.comparePrice) { 
        btnCompare.textContent = selected.dataset.comparePrice; 
        btnCompare.style.display = 'inline'; 
      } else { 
        btnCompare.style.display = 'none'; 
      } 
 
      if (stickyPrice) { 
        stickyPrice.textContent = activePrice; 
      } 
 
      if (stickyCompare) { 
        if (selected.dataset.comparePrice) { 
          stickyCompare.textContent = selected.dataset.comparePrice; 
          stickyCompare.style.display = 'inline'; 
        } else { 
          stickyCompare.textContent = ''; 
          stickyCompare.style.display = 'none'; 
        } 
      } 
 
    } 
 
    // variant select 
    variantItems.forEach(item => { 
      item.addEventListener('click', () => { 
        variantItems.forEach(v => v.classList.remove('selected')); 
        item.classList.add('selected'); 
        variantInput.value = item.dataset.id; 
        updatePrices();
        updateDeliveryFrequency();
      }); 
    }); 
 
    subscriptionCheckbox?.addEventListener('change', updatePrices); 
 
    buyNowBtn.addEventListener('click', async e => { 
      e.preventDefault(); 
 
      if (buyNowBtn.classList.contains('el-loading')) return; 
 
      const selected = getSelectedVariant(); 
      if (!selected) return; 
 
      const variantId = selected.dataset.id; 
      const isSub = subscriptionCheckbox?.checked; 
      const sellingPlanId = selected.dataset.sellingPlanId; 
 
      buyNowBtn.classList.add('el-loading'); 
      buyNowBtn.setAttribute('disabled', true); 
 
      try { 
        await fetch('/cart/clear.js', { method: 'POST' }); 
 
        const items = [ 
          { 
            id: variantId, 
            quantity: 1 
          } 
        ]; 
 
        // Add selling plan only to the main product 
        if (isSub && sellingPlanId) { 
          items[0].selling_plan = sellingPlanId; 
        } 
 
        await fetch('/cart/add.js', { 
          method: 'POST', 
          headers: { 
            'Content-Type': 'application/json' 
          }, 
          body: JSON.stringify({ items }) 
        }); 
 
        window.location.href = '/checkout'; 
 
      } catch (err) { 
        console.error(err); 
 
        buyNowBtn.classList.remove('el-loading'); 
        buyNowBtn.removeAttribute('disabled'); 
 
        isCheckingOut = false; 
      } 
    }); 
 
    updatePrices(); 
    updateDeliveryFrequency();
  }); 
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});

window.addEventListener('pageshow', () => {
  isCheckingOut = false;

  document.querySelectorAll('.product-offer').forEach(section => {
    const btn = section.querySelector('[id^="buy-now"]');
    if (!btn) return;

    btn.classList.remove('el-loading');
    btn.disabled = false;
  });
});

// faq
document.addEventListener('DOMContentLoaded', function () {
  function initAccordions() {
    const containers = document.querySelectorAll('.product-offer__accordion-container');

    containers.forEach(container => {
      const isHidden = window.getComputedStyle(container).display === 'none';
      if (isHidden) return;

      const items = container.querySelectorAll('.product-offer__acc-item');

      items.forEach(item => {
        // prevent duplicate event binding
        if (item.dataset.initialized === 'true') return;
        item.dataset.initialized = 'true';

        const trigger = item.querySelector('.product-offer__acc-item-title');
        const content = item.querySelector('.product-offer__acc-item-description');

        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.paddingBottom = '0px';

        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');

          items.forEach(otherItem => {
            const otherContent = otherItem.querySelector('.product-offer__acc-item-description');

            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              otherContent.style.height = '0px';
              otherContent.style.paddingBottom = '0px';
            }
          });

          if (isOpen) {
            content.style.height = '0px';
            content.style.paddingBottom = '0px';
            item.classList.remove('is-open');
          } else {
            item.classList.add('is-open');

            content.style.height = 'auto';
            const fullHeight = content.scrollHeight + 'px';
            content.style.height = '0px';

            requestAnimationFrame(() => {
              content.style.height = fullHeight;
              content.style.paddingBottom = '20px';
            });
          }
        });
      });
    });
  }

  // run on load
  initAccordions();

  // re-run on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initAccordions();
    }, 200);
  });
});

// video popup
document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.querySelector('[data-video-lightbox]');
  const video = lightbox?.querySelector('[data-lightbox-video]');
  const videoItems = document.querySelectorAll('[data-video-item]');
  const closeButtons = lightbox?.querySelectorAll('[data-video-close]');

  if (!lightbox || !video) return;

  function openVideo(src) {
    if (!src) return;

    video.src = src;

    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

    video.load();

    video.play().catch(function () {
      // Autoplay may be blocked by the browser.
    });
  }

  function closeVideo() {
    video.pause();
    video.removeAttribute('src');
    video.load();

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';
  }

  videoItems.forEach(function (item) {
    item.addEventListener('click', function () {
      const src = item.dataset.videoSrc;

      openVideo(src);
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeVideo);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeVideo();
    }
  });
});

// video slider
const swiperProdVideoSlider = new Swiper('.product-offer__slider-contents', {
  loop: true,
  slidesPerView: 2.1,
  spaceBetween: 12,
  breakpoints: {
    581: {
      slidesPerView: 3.1,
      spaceBetween: 15,
      loop: false,
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.product-offer__slider-item-inner');

  videoItems.forEach(function (item) {
    const container = item.querySelector('.product-offer__slider-item-inner-container');
    const video = container.querySelector('.custom-video');
    const playButton = container.querySelector('.product-offer__slider-play-button');

    playButton.addEventListener('click', function (e) {
      e.stopPropagation();
      video.play();
      playButton.style.display = 'none';
    });

    video.addEventListener('click', function () {
      if (!video.paused) {
        video.pause();
        playButton.style.display = 'block';
      }
    });
  });
});
